// firebaseConfig.jsx
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
   apiKey: "AIzaSyDA81jfwml3B4RPSZ93D0J_78DX1En7Ngs",
  authDomain: "mubacart.firebaseapp.com",
  projectId: "mubacart",
  storageBucket: "mubacart.firebasestorage.app",
  messagingSenderId: "742909314955",
  appId: "1:742909314955:web:df8547937bcb677b59518e"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const db = getDatabase(app);
const auth = getAuth(app);
const storage = getStorage(app); // Initialize Firebase storage

export { db, auth, storage };
